import React, { useState } from 'react'

const GreyButton = ({
  icon: Icon,
  label,
  onClick,
  type,
  style = {},
}: {
  icon?: React.FunctionComponent
  label: string
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
  style?: React.CSSProperties
}) => {
  const [hover, setHover] = useState(false)

  return (
    <button
      onClick={() => onClick && onClick()}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      type={type}
      style={{
        minWidth: '150px',
        width: '100%',
        margin: '0.3rem auto',
        padding: '0.5rem 0',
        background: 'var(--darker-grey)',
        border: 'none',
        borderRadius: '2rem',
        color: 'var(--lighter-grey)',
        cursor: 'pointer',
        boxShadow: hover ? '0px 3px 15px 2px var(--darker-grey)' : 'none',
        ...style,
      }}
    >
      {Icon ? <Icon /> : null}
      <p style={{ fontSize: '1rem', fontWeight: '300', textAlign: 'center' }}>{label}</p>
    </button>
  )
}

export default GreyButton
